export default {
  message: {
    success: "success",
    fail: "failure"
  },
  navbar: {
    language: 'Language',
    logOut: 'Log Out', //退出登陆
    submit:'Submit', //提交
    label_options:'Label options', //标签选项
    close_other:'Close other', //关闭其他
    close_all:'Close all', //关闭所有
  },
  login: {
    title: 'Customer Login',
    logIn: 'Login',
    register:'Register'
  },
  register:{
    title:'Register',
    username:'Username',
    password:'Password',
    checkPass:'Confirm',
    captcha:'Captcha',
    submit:'Submit',
    cancel:'Cancel',
  },
  sidebar:{
    financial:'Financial',
    accountDetails:'Account details',
    billingDetails:'Billing details',
    account:'Account',
    personalInformation:'Personal information',
    changePassword:'Change password',
    affiliation:'Affiliation',
    earnings:'Earnings',
    payoutRequests:'Payout requests',
    payoutList:'Payout list',
    about:'About'
  },
  account:{
    accountBalance:'Account balance', //账户余额
    pendingPayment:'Pending payment', //已用额度
    commissionAmount:'Commission amount', //佣金金额
    availableBalance:'Available balance', //剩余金额
    paymentInformation:'Payment information', //收款银行列表
    currency:'Currency',  //币种
    accountName:'Account name', //账户名称
    bankAccount:'Bank account',  //银行账号
    bankName:'Bank name', //银行名称
    bankAddress:'Bank address', //银行地址
    account:'Account',//账目
    rechargeApplication:'Recharge application', //充值申请
    rechargeAccount:'Recharge account', //充值账目
    paymentAccount:'Payment account', //付款账目
    applicationAccount:'Application account', //申请账目
    rechargeCurrency:'Recharge currency', //充值币种
    transactionNumber:'Transaction number', //交易编号
    exchangeRate:'Exchange rate', //当时汇率
    amountOfArrival:'Amount of arrival', //到账金额
    typesOf:'Types of', //类型
    remarks:'Remarks', //备注
    timeOfArrival:'Time of arrival', //到账时间
    creationTime:'Creation time', //创建时间
    status:'Status',   //状态
  },
  tradeStatus:{
    waitReview:'Wait review', //等待审核
    success:'Success',  //交易成功
    failed:'Failed', //交易失败
    cancel:'Cancel',  //取消交易
  },
  typeOf:{
    recharge:'Recharge', //充值
  },
  bill:{
    myBillDetails:'My bill details',//我的账单明细
    time:'Time', //时间
    amountOfConsumption:'Amount of consumption(USD)', //消费金额
    consumptionType:'Consumption Type', //消费类型
    consumptionContent:'Consumption content', //消费内容
  },
  personal:{
    accountInformation:'Account information',  //账号信息
    loginAccount:'Login account',  //登陆账号
    userName:'User name', //用户名称
    phoneNumber:'Phone number', //手机号码
    personalInformation:'Personal information', //个人信息
    company:'Company', //公司
    companyAddress:'Address', //公司地址
    country:'Country', //国家
    area:'Area', //省级区域
    city:'City', //城市
    language:'Language',//语音
  },
  password:{
    changePassword:'change Password', //修改密码
    enterOldPassword:'Enter old password', //输入旧密码
    newPassword:'Enter new password', //输入新密码
    confirmNewPassword:'Confirm new password', //确认新密码
  },
  http:{
    unauthorized:'Unauthorized, please log in again',//未授权，请重新登录
  },
  earnings: {
    myLink: "My promotion link",
    myRegisterLink: "My registration promotion link",
    message1: "You (the referrer) will receive a 1% revenue share on the money your referral spends with us at all time, no matter how much he spends.",
    message2: "Additionally, if your referral spends this much money with us after the first 30 days he suscribed to our app, we will pay you an extra bonus:",
    message3: "Please note that this is a one time bonus only. Also, the 30 days countdown starts as soon as the referral suscribes to our app.",
    detailTitle: "My promotion details",
    column1: "Customer ID",
    column2: "Customer name",
    column3: "Registration time",
    column4: "First commission time",
    column5: "Commission today",
    column6: "7 days commission",
    column7: "30 days commission",
    column8: "Cumulative commission",
    column9: "Bonus",
    column10: "Commission rate",
  },
  payout: {
    totalRevenue:"Total revenue",
    withdrawn:"Withdrawn",
    withdrawable:"Withdrawable",
    withdrawalApplication:"Withdrawal application"
  },
  payoutList: {
    myWithdrawalList: "My withdrawal list",
    column1: "My withdrawal list",
    column2: "Withdrawal amount (USD)",
    column3: "Withdrawal currency",
    column4: "Exchange rate",
    column5: "Actual withdrawal amount",
    column6: "Remarks",
    column7: "Application time",
    column8: "Complete time",
    column9: "Status",
  }
}
